// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2JtPp","gfeWrapper":"CalendarEvent_gfeWrapper__3SZlW"};